module.exports = __webpack_public_path__ + "img/5-2.17fc6139.png";